import { NextgenDOMPurify } from '@nextgen-web-framework/all';
import { FC } from 'react';
import { isRichText } from '../../../utils';
import { ShortDescriptionPropsTypes } from './types/propsTypes';
import styles from './ShortDescription.module.scss';
import { DescType } from './types/enums';

const ShortDescription: FC<ShortDescriptionPropsTypes> = ({
  shortDescription,
  descType,
  className,
  descriptionRef,
}: ShortDescriptionPropsTypes): JSX.Element => {
  const descriptionClassName = () => {
    switch (descType) {
      case DescType.DESCPRODUCTDETAILS:
        return 'short-description-product-details-container';
      default:
        return 'short-description-container';
    }
  };
  return (
    <>
      {shortDescription && (
        <div
          className={`${styles[descriptionClassName()]} ${className}`}
          ref={descriptionRef}
          data-testid="product-short-description"
        >
          <div
            className={`${styles['short-description']}
             ${isRichText(shortDescription) ? styles['rich-text'] : ''}`}
            dangerouslySetInnerHTML={{ __html: NextgenDOMPurify(shortDescription) }}
          ></div>
        </div>
      )}
    </>
  );
};

export default ShortDescription;
export type { ShortDescriptionPropsTypes };
export { DescType };
